module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/babel-runtime/core-js/symbol/iterator.js
// module id = 1984
// module chunks = 2